import { useState, useEffect, useCallback } from 'react';
import api from '../../api';

/**
 * Custom hook for managing food categories
 * Provides category fetching with caching and loading states
 */
export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.get('/category/categories');
      if (response.data && response.data.success) {
        setCategories(response.data.data);
      } else {
        const errorMsg = 'Failed to fetch categories';
        setError(errorMsg);
        console.error(errorMsg);
      }
    } catch (err) {
      const errorMsg = 'Error fetching categories';
      setError(errorMsg);
      console.error(errorMsg, err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return {
    categories,
    loading,
    error,
    refetch: fetchCategories
  };
};
